module.exports = __webpack_public_path__ + "img/shoulder width.9c909f17.png";